import { maxLength } from '@reliance/forms-js/lib/validation';
import { SpecialCondition } from '@reliance/types/models/SpecialCondition';
import { AxiosResponse } from 'axios';
import { FORM_ERROR } from 'final-form';
import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Form as FinalForm } from 'react-final-form';
import api from '../common/api';
import { IStatusResponse } from '../common/reliance-api-service';
import { TextInput } from '../form/TextInput';

type RemoveModalProps = {
  condition: SpecialCondition;
  onClose(saved?: boolean): void;
}

type RemoveConditionData = {
  id: number;
  reason: string;
};

const save = (data: RemoveConditionData) =>
  api.delete(`/condition/${data.id}`, { params: { description: data.reason ?? '' } }).catch((err) => {
    return { [FORM_ERROR]: err };
  })

const RemoveModal = (props: RemoveModalProps) => {
  const [initialValues] = useState<Partial<RemoveConditionData>>({
    id: props.condition.id,
    reason: ''
  });

  return (
    <Modal show={true} onHide={() => props.onClose(false)}>
      <FinalForm
        initialValues={initialValues}
        onSubmit={(data: RemoveConditionData) =>
          save(data).then((response: AxiosResponse<IStatusResponse>) => {
            if (response && response.data) {
              props.onClose(true);
            }
          })
        }
        render={({ handleSubmit, submitting, submitError }) => (
          <form onSubmit={handleSubmit} method='post'>
            <Modal.Header>
              <Modal.Title>Remove Condition</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {submitError &&
                <Alert variant="danger">{submitError}</Alert>
              }

              <TextInput
                name="reason"
                label="Reason / description"
                validationRules={[maxLength(250)]} />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => props.onClose()} disabled={submitting}>
                Cancel
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={submitting}>
                {submitting ? 'Removing' : 'Remove'}
              </Button>
            </Modal.Footer>
          </form>
        )} />
    </Modal>
  );
};

export default RemoveModal;
